import React from 'react';
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Breadcrumb } from 'antd';

import { useStatsList as useOrganizationStats } from 'modules/mandatoryRequirement/hooks';

import * as Grid from "components/Grid";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import Card from 'components/Card';
import { LoadingOutlined } from '@ant-design/icons';

import cls from "./OrganizationStats.module.scss";

const OrganizationStats = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { items, isFetched } = useOrganizationStats({
    enabled: true,
    params: {
      perPage: 1_000_000_000,
    }
  });
  
  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item>
        <Breadcrumb.Item href='/mandatory-requirement/register'>{t('mandatory-requirements')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('organization_stats')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align='left' text={t('organization_stats')} />

      <Spacer size={40} />

      <Spacer size={40} />

      {items.length > 0 && (
        <Grid.Row gutter={[24, 24]}>
          {items
            .map(item => (
              <Grid.Col span={6} key={item.id}>
                <Card
                  id={item.id}
                  uuid={item.file_response.uuid}
                  name={item.name[i18n.language]}
                  count={item.register_requirements_count}
                  onClick={() => navigate(`/mandatory-requirement?organizationId=${item.id}`)}
                />
              </Grid.Col>
            ))}
        </Grid.Row>
      )}

      {
        items.length === 0 && isFetched && (<div className={cls.noData}>{t('no_data')}</div>)
      }

      {
        !isFetched && (<div className={cls.loading}><LoadingOutlined /></div>)
      }

      <Spacer size={140} />
    </Container>
  )
}

export default OrganizationStats;